import React from "react";
import styled from "styled-components";
import Box from "react-raster";
import { Eyebrow, Copy } from "../Typography";
import theme from "../../theme";
import { getImage, GatsbyImage } from "gatsby-plugin-image";

const Container = styled(Box)`
  width: 100%;

  @media (${theme.mq.m}) {
    width: 316px;
  }
`;

const Title = styled.h3`
  font-style: normal;
  font-weight: normal;
  font-size: 44px;
  line-height: 100%;
  color: ${({ theme, $colour = "grey" }) => theme.colours[$colour]};
`;

const List = styled.ul`
  display: flex;
  flex-direction: column;
`;

const ListItem = styled.li`
  list-style: none;
  display: block;
  border-top: 1px solid #cbcbcb;
  font-size: 20px;
  font-family: "Supply", monospace;
  font-weight: normal;
  font-style: normal;
  line-height: 16px;
  opacity: 0.5;
  padding: 9px 0 3px 0;
  margin-top: 16px;
  color: ${({ theme, $colour }) => ($colour ? theme.colours[$colour] : "#000")};

  @media (${theme.mq.m}) {
    margin-top: 28px;
  }
`;

const ImageWrapper = styled.div`
  margin-bottom: 30px;
  img {
    max-width: 100%;
  }
`;

function BulletedCard({
  title,
  image,
  eyebrow,
  eyebrowIndex,
  bulletedList,
  description,
  descriptionColour,
  titleColour,
}) {
  return (
    <Container marginBottom={[1, 0]}>
      {image && (
        <ImageWrapper>
          <GatsbyImage
            image={getImage(image)}
            alt={image?.description || "image"}
          />
        </ImageWrapper>
      )}
      <Eyebrow colour="blue">{eyebrowIndex}</Eyebrow>
      <Eyebrow colour={titleColour || "grey"}>{eyebrow}</Eyebrow>
      <Title colour={titleColour || "grey"}>{title}</Title>
      <Copy colour={descriptionColour}>{description}</Copy>
      {bulletedList && (
        <List>
          {bulletedList.map((item, i) => (
            <ListItem key={i} $colour={titleColour}>
              {item}
            </ListItem>
          ))}
        </List>
      )}
    </Container>
  );
}

export default BulletedCard;
